<template>
  <div>
    <div class="header">
      <div v-show="isNoMessage" class="container">
        <div class="index-data">
          <img class="bg" src="../../assets/app/99bg2.png">
          <div class="data-block">
            <HeaderTop @fetchData="fetchData" class="top-data" :data="headerData"></HeaderTop>
            <div class="bottom-data">
              <div class="bottom-data-item">
                <div class="item-title">{{headerData.threeTitle | valueFromt}}</div>
                <div class="item-data">{{headerData.threeData}}</div>
              </div>
              <div class="bottom-data-item">
                <div class="item-title">{{headerData.oneTitle | valueFromt}}</div>
                <div class="item-data">{{headerData.oneData}}</div>
              </div>
              <div class="bottom-data-item">
                <div class="item-title">{{headerData.twoTitle | valueFromt}}</div>
                <div class="item-data">{{headerData.twoData}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="showTable" class="rolling-table meal-table" ref="tableBox">
          <table cellpadding="0" cellspacing="0" ref="rollingTable">
            <tr>
              <th class="cross rows">区域</th>
              <th class="rows">当日</th>
              <th class="rows">昨日</th>
              <th class="rows">比昨日</th>
              <th class="rows">排名</th>
            </tr>
            <tr @click="goToRouter(i)" v-for="(l,i) in list" :key='i'>
              <td class="cols">{{l.name | valueFromt}}</td>
              <td>{{l.day_count}}</td>
              <td>{{l.last_count}}</td>
              <td>
                <span v-if="validateVal(l.ratio) <= 0" class="down">↓{{l.ratio}}</span>
                <span v-if="validateVal(l.ratio) > 0" class="up">↑{{l.ratio}}</span>
              </td>
              <td>{{i + 1}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div v-show="!isNoMessage" class="no-message">
      <NoMessage :value="value"></NoMessage>
    </div>
  </div>
</template>
<script>
  import {Indicator} from 'mint-ui';
  import HeaderTop from 'com/app/setMeal/headerTop.vue';
  import NoMessage from 'com/app/common/noMessage.vue';
  import commonMixin from 'mixins/common/common.js';
  import {createIScroller, refreshScroller} from "libs/iscrollTable";
  import {formatDateTime, deepCopyObj} from "libs/common/common";
  export default {
    components: {
      HeaderTop,
      NoMessage
    },
    mixins: [commonMixin],
    data () {
      return {
        isNoMessage: true,
        isFirstEnter: false, // 是否第一次进入，默认false
        title: '99元套餐',
        value: {
          title: '本日本区域暂无',
          subTitle: '99套餐业务发展，要加油哦!',
        },
        initList: [],
        list: [],
        headerData: {
          family: '0',
          yesday: '0',
          compareDay: '0',
          oneTitle: '',
          twoTitle: '',
          threeTitle: '',
          oneData: '0',
          twoData: '0',
          threeData: '0',
        },
        scroll: {
          scroller: null
        },
        areaId: 'HN',
        mode: "",
        areaList: [],
        type: this.$route.query.type || "99", //type只有三个 “99”， “kd”, "kh" 分别对应 99，放号，宽带
        eparchy: "", //代表市
        city: "", //代表县级
        date: "",
        timerId: null,
        showTable: false, //表格的数据循环要时间，等循环完了再显示
      }
    },
    computed: {},
    watch: {},
    filters: {
      // 去掉数值前面的字母
      valueFromt: function (value) {
        if (!value) return "";
        if (value.includes("_")) {
          return value.slice(2);
        } else {
          return value;
        }
      }
    },
    methods: {
      validateVal (value) {
        value = value.substring(0, value.length - 1);
        return Number(value);
      },
      goBack () {
        this.$router.go(-1);
      },
      goToRouter (i) {
        let id = this.list[i]._id;
        let name = this.list[i].name;
        let model = deepCopyObj(this.$store.state.meal.model);
        let floor = model.floor;
        if (name === "未知城市" || floor === 2) {
          return;
        }
        model.areaId = id;
        model.name = name;
        if (floor === 0) {
          model.parent.name = name;
          model.parent.pid = id;
        }
        model.floor = floor + 1;
        this.$store.commit("SAVE_MEAL_MODEL", {
          model: model
        });
      },
      fetchData () {
        let meal = this.$store.state.meal;
        this.date = formatDateTime(meal.date, "YYYY-MM-DD");
        this.areaId = meal.model.areaId;
        if (meal.model.floor === 0) {
          this.city = "";
          this.eparchy = "";
        } else if (meal.model.floor === 1) {
          this.eparchy = meal.model.areaId;
          this.city = "";
        } else {
          this.city = meal.model.areaId;
          this.eparchy = meal.model.parent.pid;
        }
        this.getData();
      },
      getData () {
        this.list = [];
        Indicator.open();
        this.$http.get(this.$urls.rank, {
          params: {
            type: this.type, //type只有三个 “99”， “kd”, "kh" 分别对应 99，放号，宽带
            city: this.city,
            date: this.date,
            eparchy: this.eparchy
          }
        }).then((res) => {
          Indicator.close()
          if (res.data.code === 200) {
            this.list = res.data.data.list;
            this.headerData.family = res.data.data.curDayCount
            this.headerData.yesday = res.data.data.lastDayCount
            this.headerData.compareDay = res.data.data.differ
            this.getDrillDown()
          }
        }).catch(error => {
          Indicator.close();
          console.log(error);
        });
      },
      // 获取下钻的地区数据
      getDrillDown () {
        if (this.mode === "date") {
          this.areaList.forEach((e, i) => {
            this.list.forEach((el, j) => {
              if (e.code_id === el._id) {
                el.name = e.name;
                return;
              }
            })
          });
          let delListIndex = [];
          let unknow = {day_count: 0, hour_count: 0, last_count: 0, name: "未知城市", ratio: 0, _id: "0000"};
          let flag = false;
          this.list.forEach((obj, i) => {
            if (!obj["name"]) {
              unknow.day_count += Number(obj.day_count);
              unknow.last_count += Number(obj.last_count);
//                unknow.ratio += this.validateVal(obj.ratio);
              delListIndex.push(i);
              if (!flag) {
                flag = true;
              }
            }
          });
          delListIndex.forEach((obj, i) => {
            if (i === 0) {
              this.list.splice(obj, 1);
            } else {
              this.list.splice(obj - i, 1);
            }
          });
          if (flag) {
            if (unknow.last_count === 0) {
              unknow.ratio = "-0.00%"
            } else {
              unknow.ratio = ((unknow.day_count - unknow.last_count) / unknow.last_count).toFixed(2);
              unknow.ratio += "%";
            }
            this.list.push(unknow);
            this.list.sort((a, b) => {
              return this.validateVal(b.ratio) - this.validateVal(a.ratio);
            });
            flag = false;
          }
          this.showTable = true;
          if (this.list[0]) {
            this.headerData.oneTitle = this.list[0].name;
            this.headerData.oneData = this.list[0].day_count;
          } else {
            this.headerData.oneTitle = "";
            this.headerData.oneData = "";
          }
          if (this.list[1]) {
            this.headerData.twoTitle = this.list[1].name;
            this.headerData.twoData = this.list[1].day_count;
          } else {
            this.headerData.twoTitle = "";
            this.headerData.twoData = "";
          }
          if (this.list[2]) {
            this.headerData.threeTitle = this.list[2].name;
            this.headerData.threeData = this.list[2].day_count;
          } else {
            this.headerData.threeTitle = "";
            this.headerData.threeData = "";
          }
          this.$nextTick(() => {
            let boxHeight = this.$refs.tableBox.offsetHeight;
            let tblHeight = this.$refs.rollingTable.offsetHeight;
            if (tblHeight >= boxHeight) {
              let parentHeight = window.innerHeight;
              let tblTop = this.$refs.tableBox.offsetTop;
//              this.$refs.tableBox.style.height = `${parentHeight - tblTop - 5}px`;
            }
          });
//          if (this.scroll.scroller === null) {
//            this.scroll.scroller = createIScroller(".meal-table");
//          } else {
//            refreshScroller();
//          }
          return;
        }
        this.$http.post(this.$urls.getDrillDown, {
          area_id: String(this.areaId)
        }).then((res) => {
          Indicator.close();
          if (res.data.code === 200) {
            this.areaList = res.data.data;
            this.areaList.forEach((e, i) => {
              this.list.forEach((el, j) => {
                if (e.code_id === el._id) {
                  el.name = e.name;
                  return;
                }
              });
            });

            let unknow = {day_count: 0, hour_count: 0, last_count: 0, name: "未知城市", ratio: 0, _id: "0000"};
            let flag = false;
            let delListIndex = [];
            this.list.forEach((obj, i) => {
              if (!obj["name"]) {
                unknow.day_count += Number(obj.day_count);
                unknow.last_count += Number(obj.last_count);
//                unknow.ratio += this.validateVal(obj.ratio);
//                this.list.splice(i, 1);
                delListIndex.push(i);
                if (!flag) {
                  flag = true;
                }
              }
            });
            delListIndex.forEach((obj, i) => {
              if (i === 0) {
                this.list.splice(obj, 1);
              } else {
                this.list.splice(obj - i, 1);
              }
            });
            if (flag) {
              if (unknow.last_count === 0) {
                unknow.ratio = "-0.00%"
              } else {
                unknow.ratio = ((unknow.day_count - unknow.last_count) / unknow.last_count).toFixed(2);
                unknow.ratio += "%";
              }
              this.list.push(unknow);
              this.list.sort((a, b) => {
                return this.validateVal(b.ratio) - this.validateVal(a.ratio);
              });
              flag = false;
            }

            this.showTable = true;
            if (this.list[0]) {
              this.headerData.oneTitle = this.list[0].name;
              this.headerData.oneData = this.list[0].day_count;
            } else {
              this.headerData.oneTitle = "";
              this.headerData.oneData = "";
            }
            if (this.list[1]) {
              this.headerData.twoTitle = this.list[1].name;
              this.headerData.twoData = this.list[1].day_count;
            } else {
              this.headerData.twoTitle = "";
              this.headerData.twoData = "";
            }
            if (this.list[2]) {
              this.headerData.threeTitle = this.list[2].name;
              this.headerData.threeData = this.list[2].day_count;
            } else {
              this.headerData.threeTitle = "";
              this.headerData.threeData = "";
            }
            this.$nextTick(() => {
              let boxHeight = this.$refs.tableBox.offsetHeight;
              let tblHeight = this.$refs.rollingTable.offsetHeight;
              if (tblHeight >= boxHeight) {
                let parentHeight = window.innerHeight;
                let tblTop = this.$refs.tableBox.offsetTop;
//                this.$refs.tableBox.style.height = `${parentHeight - tblTop - 5}px`;
              }
            });
//            if (this.scroll.scroller === null) {
//              this.scroll.scroller = createIScroller(".meal-table");
//            } else {
//              refreshScroller();
//            }
          }
        }).catch(error => {
          this.showTable = true;
          Indicator.close();
          console.log(error);
        });
      }
    },
    mounted () {
      // this.timerId = setInterval(this.getData, 10000)
    },
    beforeDestroy () {
      // clearInterval(this.timerId)
    },
    created () {
      if (String(this.type) === '99') {
        this.setTitle({'title': '99元套餐'});
      } else if (String(this.type) === 'kd') {
        this.setTitle({'title': '新增宽带完工量'});
      } else {
        this.setTitle({'title': '放号数'});
      }
      // 只有第一次进入或者刷新页面后才会执行此钩子函数
      // 使用keep-alive后（2+次）进入不会再执行此钩子函数
      this.isFirstEnter = true;
      let dateObj = this.$store.state.meal.date;
      this.date = formatDateTime(dateObj, "YYYY-MM-DD");
    },
    activated () {
      // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
      this.$route.meta.isBack = false
      // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
      this.isFirstEnter = false;
    },
    beforeRouteEnter (to, from, next) {
      // 利用路由元信息中的meta字段设置变量，方便在各个位置获取。这就是为什么在meta中定义isBack
      if (from.name == 'setMealAreaDetails') {
        to.meta.isBack = true;
        //判断是从哪个路由过来的，
        //如果是 setMealAreaDetails 过来的，表明当前页面不需要刷新获取新数据，直接用之前缓存的数据即可
      }
      next();
    },
  }

</script>
<style lang="less" scoped>
  .header {
    height: 0rem; // height: 7.8rem;
    .mint-header {
      background-color: #0384df;
      height: 0.8rem;
      z-index: 9;
      font-size: 0.36rem;
      font-family: 'PingFang-SC-Bold';
    }
    .mintui {
      font-size: 0.36rem;
    }
  }

  .index-data {
    position: relative;
    padding-top: 1.8rem;
    height: 4.3rem;
    background-color: #0384DF;
    .data-block {
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: 9;
      top: 0;
    }
    .bg {
      height: 3.7rem;
      margin-top: 0.4rem;
      padding-left: 0.2rem;
      /* 补父div高度 */
    }
  }

  .rolling-table {
    font-size: 0.28rem;
    color: #86939a;
    background-color: #ffffff;
    /*overflow: hidden;*/
    width: 100%;
    /*max-height: 6rem;*/
    -webkit-overflow-scrolling: touch;
    position: relative;
  }

  .rolling-table {
    table {
      border-collapse: collapse;
      width: 100%;
      table-layout: auto;
      text-align: center;
      background-color: transparent;
      th {
        position: relative;
        font-weight: normal;
        background-color: #f2f5f4;
        color: #43484d;
        font-size: 0.3rem;
        height: 0.64rem;
        line-height: 0.64rem;
        white-space: nowrap;
        padding: 0.1rem 0.2rem;
        &.rows {
          z-index: 3;
        }
        &.cross {
          z-index: 5;
        }
      }
      tr {
        border-bottom: solid 1px #f2f5f4;
      }
      td {
        position: relative;
        color: #86939e;
        font-size: 0.26rem;
        padding: 0.2rem 0.1rem;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
        // width: 100%;
        white-space: pre-wrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 2rem;
        &.cols {
          z-index: 3;
          background-color: #fff;
        }
      }
    }
  }

  .down {
    color: #239610;
  }

  .up {
    color: #ffc72b;
  }

  .top-data div:first-child {
    color: #ffffff;
    font-size: 0.5rem;
    text-align: center;
    margin-top: 1rem;
    position: relative;
    padding-left: 0.3rem;
  }

  .top-data .unit {
    font-size: 0.2rem;
    margin-left: 0.07rem;
  }

  .top-data .koujing {
    font-size: 0.2rem;
    position: absolute;
    bottom: 6px;
    right: 0.5rem;
  }

  .top-data div:last-child {
    text-align: center;
    margin-top: 0.15rem;
    font-size: 0.25rem;
  }

  .time-val {
    width: 50%;
    float: left;
    color: #ffffff;
  }

  .time-val .down,
  .time-val .up {
    margin-left: 0.25rem;
  }

  .bottom-data {
    width: 100%;
    padding: 0 0.15rem;
    position: absolute;
    z-index: 1;
    bottom: 0.4rem;
    box-sizing: border-box;
  }

  .bottom-data-item:nth-child(2) {
    top: -0.3rem;
    position: relative;
  }

  .bottom-data-item {
    width: 33.3333333%;
    float: left;
    text-align: center;
    font-size: 0.4rem;
  }

  .item-title {
    padding: 0.4rem 0rem 0;
    font-size: 0.26rem;
    white-space: normal;
    color: #43484D;
  }

  .bottom-data-item:nth-child(2) .item-data:nth-child(2) {
    color: #fcc92e;
  }

  .item-data {
    font-family: 'PingFang-SC-Heavy';
    font-size: 0.42rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/setMeal.vue